<div class="md-form md-outline bary-input-autocomplete" [formGroup]="_innerForm">
  <input
    mdbInput
    type="text"
    class="completer-input form-control mdb-autocomplete mb-0"
    formControlName="autocomplete"
    [mdbAutoCompleter]="auto"
    [placeholder]="'PLACEHOLDER.SEARCH' | translate"
    [value]="control.value"
    jhiMarkAsterisk
  />
  <label [for]="id">{{ label }}</label>
  <mdb-auto-completer [visibleOptions]="5" [optionHeight]="40" #auto="mdbAutoCompleter" [textNoResults]="'ERROR.UNKNOWN_UN_NUMBER' | translate" (select)="select($event)">
    <mdb-option *ngFor="let option of _options | async" [value]="option.value">
      {{ option.label }}
    </mdb-option>
  </mdb-auto-completer>
  <mdb-error *ngIf="control.invalid && (control.dirty || control.touched)">
    <span *ngIf="control.hasError('required')" jhiTranslate="ERROR.REQUIRED_FIELD"></span>
  </mdb-error>
</div>
